import { QueryClient } from '@tanstack/react-query'
import { isAuthError } from '@/lib/api-client'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // A 401 has already survived one refresh attempt inside `apiRequest`, and
      // a 403 is about who you are rather than when you asked. Repeating either
      // cannot change the answer, so the default retry was pure duplication -
      // it doubled every request in the 2026-08-23 401/403 storm. Everything
      // else keeps the single retry it always had.
      retry: (failureCount, error) => !isAuthError(error) && failureCount < 1,
      refetchOnWindowFocus: false,
    },
  },
})
